import { all } from "redux-saga/effects";

import spockViewSagas from "./containers/SpockViewPage/saga";
import WorkkardDetailSaga from "./containers/WorkkardDetail/Saga";
import Header from "./containers/Header/saga";
import WorkkardListingSaga from "./containers/WorkkardListing/saga";
import ActivityListingSaga from "./containers/ActivityListing/saga";
import DiaryCreationSaga from "./containers/CreationForms/DiaryCreation/saga";
import DiariesSaga from "./containers/Diaries/saga";
import ActivityCreationSaga from "./containers/CreationForms/ActivityCreation/saga";
import AdminPanelSaga from "./containers/AdminPanel/Saga";
import activityFormSaga from "./containers/CreationForms/AddEditActivity/store/activityFormSaga";
import skillsetTagsSaga from "./containers/CreationForms/AddEditActivity/store/skillsetTagsSaga";
import assignmentMethodSaga from "./containers/CreationForms/AddEditActivity/store/assignmentMethodSaga";
import workkardFormSaga from "./containers/CreationForms/AddEditWorkkard/store/workkardFormSaga";
import { watchFetchOrgRequest } from "./common/sagas/orgListSaga";

export default function* rootSaga() {
  yield all([
    ...spockViewSagas,
    ...WorkkardDetailSaga,
    ...Header,
    ...WorkkardListingSaga,
    ...ActivityListingSaga,
    ...DiaryCreationSaga,
    ...DiariesSaga,
    ...ActivityCreationSaga,
    AdminPanelSaga(),
    activityFormSaga(),
    workkardFormSaga(),
    skillsetTagsSaga(),
    assignmentMethodSaga(),
    watchFetchOrgRequest(),
  ]);
}
